<template>
    <section class="all-cases-view" id="labdaq">
      <div class="container-xxs">
        <div class="primary-content-view-new" v-loading="loading">
          <div
            class="listings listings__table listings__all-cases"
            id="all-cases-listings"
          >
            <el-table
              :data="getLabdaqCompletedOrders.data"
              height="calc(100vh - 115px)"
              :default-sort="{
                prop: orderBy,
                order: orderType == 'asc' ? 'ascending' : 'descending',
              }"
            >
              <el-table-column label="Name" prop="name"></el-table-column>
              <el-table-column
                label="Size"
                width="150"
                prop="size"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  export default {
    computed: {
      ...mapGetters("cases", ["getLabdaqCompletedOrders"]),
    },
    data() {
      return {
        loading: false,
      };
    },
  
    mounted() {
      this.fetchPendingOrders();
    },
    methods: {
      async fetchPendingOrders() {
        try {
          this.loading = true;
          await this.$store.dispatch("cases/fetchAllLabdaqCompletedOrders");
          this.loading = false;
        } catch (error) {
          this.loading = false;
          console.log(error);
        }
      },
    },
  };
  </script>
  <style lang="scss">
  #labdaq {
    .el-table table thead tr th .cell {
      padding: 3px 15px !important;
    }
    .el-table table tbody tr td .cell {
      padding: 5px 15px !important;
    }
  }
  </style>
  